import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';
const { EFPic } = createEFPic('/media/deltamax/pc/');

export default function Comp() {
    const { useLang } = useGlobal();
    const { t } = useLang('delta_max_static');

    return (
        <div className={`${css.gsapdGroupb} gsapdGroupb`}>
            <div className="ef-scroll-ani">
                <div className="ef-scroll-ani-trigger">
                    <div className="ef-scroll-ani-inter">
                        <div className="gsapdGroupb-a">
                            <div className="a-img-box">
                                <EFPic name={['img_1.webp', 'img_1.png']} className="fullImgs" alt={t('NID')}></EFPic>
                            </div>
                            <div className="a-msg-box-out">
                                <div className="a-msg-box-layout"></div>
                                <div className="a-msg-box">
                                    <div className="msg-title">{t('NID')}</div>
                                    <div className="msg-line">{t('NID_desc')}</div>
                                    <div className="msg-tips">{t('NID_notice')}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
